import React, { useMemo } from "react"

import { ShoppingCartIcon } from "@assets/icons"

const CartTotal = ({ orderSummary, domainDetails }: any) => {
  const selectedPriceTypeData = orderSummary?.selectedPriceTypeData
  const selectedAddOnData = orderSummary?.addonProductData

  const currency = useMemo(() => {
    return domainDetails?.currency_symbol || ""
  }, [domainDetails])

  const calculateTotalPrice = () => {
    let totalPrice = 0

    const transformArray = (arr) => {
      return arr.map((item) => ({
        unitCount: item?.unitCount ?? item?.quantity ?? 0,
        unit_amount: item.unit_amount ?? 0,
      }))
    }

    const transformedA = transformArray(selectedPriceTypeData || [])
    const transformedB = transformArray(selectedAddOnData || [])

    const all_products = [...transformedA, ...transformedB]

    ;(all_products || []).map((product: any) => {
      const price = product?.unit_amount ?? 0
      return (totalPrice += product?.unitCount * price)
    })
    return totalPrice.toFixed(2)
  }

  return (
    <>
      {orderSummary?.selectedPriceTypeData?.length ? (
        <div
          className={`px-2.5 py-1.5 bg-primary-200 text14Regular rounded flex items-center gap-1 w-fit`}
        >
          <ShoppingCartIcon className={"text-primary-600"} />
          <div className={"text16Medium"}>Total: {`${currency}${calculateTotalPrice()}`}</div>
        </div>
      ) : null}
    </>
  )
}

export default CartTotal
